import React, { useState, useEffect } from 'react';

import sanitizeInput from '../../../helpers/sanitizeInput';

import EditableLink from '../EditableLink';
import RestrictedTextBox from '../RestrictedTextBox.js';

import SpellCheckGroup from '../../SpellCheckGroup.js';

import './Flexigrid2.css'

// ----------------------------------------------------------------------------------
//                         Description
//
//     Flexigrid2 is a grid of input cells, defined by props.cellsHTML and props.cells
//
//     props.cells is the original implementation and creates simple input cells and boxes (boxes are borders)
//        cells = { datafield1: [ X1, X2, Y1, Y2 ], datafield2: ... }}
//        boxes = { box1: [ X1, X2, Y1, Y2 ], box2: ... }
//        data = { datafield1: 'value1', datafield2: ... }
//          data is normally tied to a character data state variable
//          when an input field is changed, data is updated using the OnDataChange function
//
//     props.cellsHTML is a newer implementation that includes cell types. It is an array of dictionaries
//        cellsHTML = [ { name: 'datafield1', coords: [X1,X2,Y1,Y2], type: 'input | editableLink' }, { name: 'datafield2', ... }]
//
//     
//     (c) DXA Development 2023
// ----------------------------------------------------------------------------------


function Flexigrid2(props) {

    // ------------ parameters ---------------

    // ------ inherited state variables ------

    const rowSize = props.rowSize || '40px';
    const colSize = props.colSize || '300px';
    const gridID = props.id || 'flexi';
    const classRoot = props.classRoot || 'fl';
    const inheritedClasses = props.className || '';
    const cells = props.cells || {};
    const cellsHTML = props.cellsHTML || {};
    const data = props.data || {};
    const onDataChange = props.onDataChange || (() => {});
    const boxes = props.boxes || {};
    const options = props.options || {};
    let spellCheckFullArray = [];
    const globalState = props.globalState;
    const layout = globalState[3];

    var handleClickFlexi = options.handleClick || {}; 
    var spellUpdaters = options.spellUpdaters || {};

    // -------- local state variables --------

    let [ spellStatus, setSpellStatus ] = useState(['Empty','Empty','Empty','Empty','Empty','Empty'])

    // names of the toggle states are determined by name
    const [expandedStates, setExpandedStates] = useState({
      AttXbutExpanded: false,
      ComXbutExpanded: false,
      WeaXbutExpanded: false,
      ArmXbutExpanded: false,
      SavXbutExpanded: false,
      PotXbutExpanded: false,
      MagXbutExpanded: false,
      OthXbutExpanded: false,
      FolXbutExpanded: false,
      SpeXbutExpanded: true
    });

    // -------- start-up code  ---------------

    // ---------- HANDLER FUNCTIONS ----------

    const handleClickCollapse = ( name, forceClose=false ) => {

        const element = document.getElementById(gridID);
        if (!element) return
        const computedStyle = window.getComputedStyle(element);
        const gridTemplateRows = computedStyle.gridTemplateRows.split(' ');
        
        let categories = [] // data elements charMobile-grid-full-my{}##
        let elements = []  // charMobile elements charMobile-grid-full-
        let boxElements = [] // box elements cf-
        let rowsToCollapse = 3
        let startRow

        if (name === 'AttXbut') {
          let cat1 = ['ClassTxt','LvlTxt','RaceTxt','AliTxt','HeiTxt','WeiTxt','NXPTxt','XPTxt','DeiTxt','GoldTxt']
          let cat2 = ['myClass','myLevel','myRace','myAlign','myHei','myWei','myNXP','myXP']
          let cat3 = ['StrTxt','IntTxt','WisTxt','DexTxt','ConTxt','ChaTxt']
          let cat4 = ['myStr','myInt','myWis','myDex','myCon','myCha']
          let cat5 = ['cf-boxClas','cf-boxRace','cf-boxHei','cf-boxXP','cf-boxNXP','cf-boxGld']
          let cat6 = ['cf-boxStrA','cf-boxStrB','cf-boxStrC','cf-boxIntA','cf-boxIntB','cf-boxIntC','cf-boxWisA','cf-boxWisB','cf-boxWisC','cf-boxDexA','cf-boxDexB','cf-boxDexC','cf-boxConA','cf-boxConB','cf-boxConC','cf-boxChaA','cf-boxChaB','cf-boxChaC']

          elements = [...cat1, ...cat2, ...cat3, ...cat4 ]
          boxElements = [...cat5, ...cat6]
          rowsToCollapse = 9
          const Element1 = document.getElementById(`${gridID}-myClass`)
          if ( !Element1 ) return // do nothing if there is no First element
          startRow = Element1['style']['grid-row-start']
        }

        if (name === 'ComXbut') {
          categories = ["ACTxt", "BaseAC", "HPbase", "Natt"];
          const box1 = ['cf-boxAC','cf-boxHP', 'cf-boxACb', 'cf-boxToHit', 'cf-boxMov']
          boxElements =[...box1]
          rowsToCollapse = 4
          const Element1 = document.getElementById(`${gridID}-ACTxt`)
          if ( !Element1 ) return // do nothing if there is no First element
          startRow = Element1['style']['grid-row-start']
        }
        
        if (name === 'WeaXbut') {
          categories = ["Weap", "Wth", "Wdb", "Wdmg"];
          elements = ['gTotImg','WthTxt', 'WdbTxt', 'WdgTxt']
          let box1 = ['cf-boxWeaTxt','cf-boxWthTxt','cf-boxWdbTxt','cf-boxWdgTxt']
          let box2 = ['cf-boxWth1', 'cf-boxWth2', 'cf-boxWth3','cf-boxWth4','cf-boxWth5','cf-boxWth6']
          let box3 = ['cf-boxWdb1', 'cf-boxWdb2', 'cf-boxWdb3','cf-boxWdb4','cf-boxWdb5','cf-boxWdb6']
          let box4 = ['cf-boxWdg1', 'cf-boxWdg2', 'cf-boxWdg3','cf-boxWdg4','cf-boxWdg5','cf-boxWdg6']
          let box5 = ['cf-boxWea1', 'cf-boxWea2', 'cf-boxWea3','cf-boxWea4','cf-boxWea5','cf-boxWea6']
          boxElements = [...box1, ...box2, ...box3, ...box4, ...box5]
          rowsToCollapse = 5
          const Element1 = document.getElementById(`${gridID}-myWeap1`)
          if ( !Element1 ) return // do nothing if there is no First element
          startRow = Element1['style']['grid-row-start']
        }

        if (name === 'SavXbut') {
          categories = ["Sav", "Sbon"];
          rowsToCollapse = 3
          const Element1 = document.getElementById(`${gridID}-mySav1`)
          if ( !Element1 ) return // do nothing if there is no First element
          startRow = Element1['style']['grid-row-start']
        }

        if (name === 'ArmXbut') {
          categories = ["Arm", "Ab"];
          const boxes1 = ['cf-boxArm1', 'cf-boxArm2','cf-boxArm3','cf-boxArm4','cf-boxArm5','cf-boxArm6',]
          boxElements = [...boxes1, 'cf-boxAC1', 'cf-boxAC2', 'cf-boxAC3', 'cf-boxAC4', 'cf-boxAC5', 'cf-boxAC6','cf-boxArmTxt']
          rowsToCollapse = 5
          const Element1 = document.getElementById(`${gridID}-myArm1`)
          if ( !Element1 ) return // do nothing if there is no First element
          startRow = Element1['style']['grid-row-start']
        }

        if (name === 'PotXbut') {
          categories = ["Pot", "Qpo"];
          rowsToCollapse = 6
          const Element1 = document.getElementById(`${gridID}-myPot1`)
          if ( !Element1 ) return // do nothing if there is no First element
          startRow = Element1['style']['grid-row-start']
        }

        if (name === 'MagXbut') {
          categories = ["Mag"];
          rowsToCollapse = 5
          const Element1 = document.getElementById(`${gridID}-myMag1`)
          if ( !Element1 ) return // do nothing if there is no First element
          startRow = Element1['style']['grid-row-start']
        }

        if (name === 'OthXbut') {
          categories = ["Oth"];
          rowsToCollapse = 7
          const Element1 = document.getElementById(`${gridID}-myOth1`)
          if ( !Element1 ) return // do nothing if there is no First element
          startRow = Element1['style']['grid-row-start']
        }

        if (name === 'FolXbut') {
          categories = ["Fol"];
          elements = [ "Rabi", "Rabi-in", "RacTxt"]
          boxElements = ['cf-boxRacTxt']
          rowsToCollapse = 11
          const Element1 = document.getElementById(`${gridID}-myFol1`)
          if ( !Element1 ) return // do nothing if there is no First element
          startRow = parseInt(Element1['style']['grid-row-start'])
        }

        if (name === 'SpeXbut') {
          elements = [ 'AbiTxt', 'myAbi' ]
          for (let i=1; i<=5; i++) {
            
            elements.push(`Sp${i}Txt`)
            elements.push(`Nsp${i}`)
            elements.push(`Tsp${i}`)

            for ( let j=1; j<=10; j++) {
            
              let jj = j.toString().padStart(2,'0')
              elements.push(`mySp${i}${jj}`)
              elements.push(`mySpk${i}${jj}`)
            }
          }
          
          rowsToCollapse = 28

          const Element1 = document.getElementById(`${gridID}-Sp1Txt`)
          if ( !Element1 ) return // do nothing if there is no First element
          
          startRow = parseInt(Element1['style']['grid-row-start'])
        }

        console.log(`${name} clicked state=${expandedStates[`${name}Expanded`]}`)
        
        // HIDE ROWS AND ELEMENTS
        for ( let i=0; i< rowsToCollapse; i++ ) {
          let element
          for ( let cat of categories ) {

            element = document.getElementById(`${gridID}-my${cat}${i+1}`)

            if ( name === 'WeaXbut') {
              if ( cat === 'Wth') {
                console.log('WTH element', element.classList)
                console.log('WTH element', element.classList.contains("mobile-header-value"))
              }
            }

            if ( element ) {
              if ( forceClose || expandedStates[`${name}Expanded`] ) {
                  element.style.display = !element.classList.contains("mobile-header-value") ? 'none' : 'flex'
              } else {
                  element.style.display = !element.classList.contains("mobile-header-value") ? 'flex' : 'none'
              }
            }
          }

          // close the rows here
          if ( forceClose || expandedStates[`${name}Expanded`] ) {
              gridTemplateRows[parseInt(startRow) + i -1 ] = '0px';
          } else {
                if ( startRow+i > 58 && startRow+i < 65 ) {
                  gridTemplateRows[parseInt(startRow) + i -1 ] = '10px';
                } else {
                  gridTemplateRows[parseInt(startRow) + i -1 ] = '35px';
                }
                if ( startRow+i === 56 || startRow+i === 57 ) {
                  gridTemplateRows[parseInt(startRow) + i -1 ] = '0px';
                }
          }
        }
        element.style.gridTemplateRows = gridTemplateRows.join(' ');

        
        // Show/Hide charMobile elements
        for ( let elem of elements ) {
          const element = document.getElementById(`${gridID}-${elem}`)
          // console.log('element', element)
          if ( forceClose || expandedStates[`${name}Expanded`] ) {
              if (element) element.style.display = 'none'
            } else {
                if (element) element.style.display = 'flex'  
          }
        }

        // Show/Hide box (cf-) elements
        for ( let elem of boxElements ) {
          const element = document.getElementById(`${elem}`)
          // console.log('element', element)
          if ( forceClose || expandedStates[`${name}Expanded`] ) {
              if (element) element.style.display = 'none'
            } else {
                if (element) element.style.display = 'flex'  
          }
        }


        // SET COLLAPSED STATE
        let variable = name;
        let prevState = expandedStates[`${variable}Expanded`];
        let newStates = { ...expandedStates, [`${variable}Expanded`]: !prevState };
        setExpandedStates(newStates);
        

        // setWeaponsExpanded( prev => !prev )
    
    }

    // ------------- useEffect ---------------

    useEffect( () => {
    

        console.log('Flexigrid2 props', props)

        if ( layout === 'mobile' ) {

            handleClickCollapse('ComXbut', true)
            handleClickCollapse('WeaXbut', true)
            handleClickCollapse('SavXbut', true)
            handleClickCollapse('ArmXbut', true)
            handleClickCollapse('PotXbut', true)
            handleClickCollapse('MagXbut', true)
            handleClickCollapse('OthXbut', true)
            handleClickCollapse('FolXbut', true)
            handleClickCollapse('AttXbut', true)
            handleClickCollapse('SpeXbut', true)
        
        }
    
        }, [ ]) ; //useEffect

    // ----------- Builder functions ----------

    const htmlItems = Object.entries(cellsHTML).map(([idx,cellObj]) => { 

      // cellObj is a dictionary containing information about what each cell is
      //    .name is the name
      //    .coords are the grid coordinates [X1, X2, Y1, Y2]
      //    .type defines the type of cell: { input, editableLink, img, spellButton }
      
      const { name, coords, type, options } = cellObj;

      const code = cellObj.code || ""

      const value = data[name] || '';

      try {
        spellCheckFullArray = (cellObj.spellChecks)
      }
      catch {
        spellCheckFullArray = [ spellStatus, setSpellStatus ]
      }

      /* console.log('cellname', name)
      console.log('coords', coords)
      console.log('data', data)
      console.log('value', value)
      console.log('options', options) */

      if (options) {

        if (options.spellUpdaters) {

            spellUpdaters = options.spellUpdaters
          
        }
        if (options.handleClick) {

          handleClickFlexi = options.handleClick
          
        }
      }

      const [colStart, colEnd, rowStart, rowEnd] = coords;

      /* -------- Standard Text Inputs ----------------*/
      if ( type === 'input') {
        return (
          <div  id = { gridID + '-' + name }
                className = { 'flexicell ' + classRoot + '-cell' + ( options.class ? ` ${options.class}` : '') }
                style = {{
                  width: `${(colEnd - colStart) * parseInt(colSize, 10)}px`,
                  height: '96%',
                  gridRowStart: rowStart,
                  gridColumnStart: colStart,
                  gridRowEnd: `span ${rowEnd - rowStart}`,
                  gridColumnEnd: `span ${colEnd - colStart}` }}
          >
          <input
            type="text"
            className = { 'flexiinput ' + classRoot + '-in' }
            // id = { gridID + '-' + name + '-in' }
            id = { name }  // to make it compatible with GET_DATA
            value={value}
            onChange={(event) => {
                const newData = { ...data };
                newData[name] = sanitizeInput(event.target.value);
                onDataChange(newData);
            }}
        /></div>
        )
      }


      /* -------- Restricted Text Boxes ----------------*/
      if ( type === 'restricted-text-box' ) {

        const checkStatChanges = options.action

        let optionsList = ['Option 1','Option 2','Option 3','Pancakes']
        if (options.list ) {
          optionsList = options.list
          }
      
        return (
          <div  id = { gridID + '-' + name }
                className = { 'flexicell ' + classRoot + '-cell' }
                style = {{
                  width: `${(colEnd - colStart) * parseInt(colSize, 10)}px`,
                  height: '96%',
                  gridRowStart: rowStart,
                  gridColumnStart: colStart,
                  gridRowEnd: `span ${rowEnd - rowStart}`,
                  gridColumnEnd: `span ${colEnd - colStart}` }}
          >
          <RestrictedTextBox
            options={ optionsList } 
            align="left"
            id = { name }  // to make it compatible with GET_DATA
            value = { value }
            onChange={(newValue) => {
                const newData = { ...data };
                newData[name] = sanitizeInput(newValue);
                onDataChange(newData);
                console.log('event value ', newValue );
                checkStatChanges(newData)
            }}
          /> 
          
          </div>
        )
      }


      /* -------- EDITABLE LINKS / SPELLS ARMOR WEAPONS POTIONS MAGIC OTHER ----------------*/

      if (type && type.includes('editableLink')) {
      
        const isSpell = ( name.slice(2,4) === "Sp" )

        // v0.4 old indexes
        const id = name.slice(4,6)
        const lvl = name[4]

        // v0.5 new indexes
        let tid
        if ( isSpell ) {
          const tlvl = name[4]
          tid = name.slice(5,7)
          tid = Number(tlvl) * 30 + Number(tid) - 31
        }

        return (
          <div  id = { gridID + '-' + name }
                className = {`flexicell ${classRoot}-cell ${options.class ? options.class : ''}`}
                style = {{
                  width: `${(colEnd - colStart) * parseInt(colSize, 10)}px`,
                  height: '96%',
                  gridRowStart: rowStart,
                  gridColumnStart: colStart,
                  gridRowEnd: `span ${rowEnd - rowStart}`,
                  gridColumnEnd: `span ${colEnd - colStart}` }}
          >
          <EditableLink id={name} initial={value} spellUpdaters={spellUpdaters} spellChecks={ spellCheckFullArray }
              data={ data } 
              onDataChange={ onDataChange }
              globalState={ props.globalState }
              options= { options }
              />
          { (type && type.includes('spell')) ? <SpellCheckGroup spellChecks={spellCheckFullArray[tid]} spell_ID={name} data={data} setData={onDataChange}/> : <></> }
        </div>
        )
      }

      if ( type === 'spellButton') {
        return (
          <div  id = { gridID + '-' + name }
                className = { 'flexicell ' + classRoot + '-cell' }
                style = {{
                  width: `${(colEnd - colStart) * parseInt(colSize, 10)}px`,
                  height: '96%',
                  gridRowStart: rowStart,
                  gridColumnStart: colStart,
                  gridRowEnd: `span ${rowEnd - rowStart}`,
                  gridColumnEnd: `span ${colEnd - colStart}` }}
          >

              <button onClick= { () => handleClickFlexi() } className = 'cf-in cf-spellbutton'>{value}</button>

          </div>
        )
      }

      // ---------- COLLAPSE BUTTONS ----------
      if ( type === 'collapseButton') {

        let buttonText = '🪄'
        if ( name === 'AttXbut') {
          buttonText = '💪'}
        if ( name === 'ComXbut') {
          buttonText = "🤺"}
        if ( name === 'WeaXbut') { 
          buttonText = '⚔' }
        if ( name === 'SavXbut') { 
          buttonText = '⛨' }
        if ( name === 'ArmXbut') { 
          buttonText = '🛡' }
          if ( name === 'PotXbut') { 
          buttonText = '🧪' }  
        if ( name === 'OthXbut') { 
          buttonText = '💰' }
        if ( name === 'FolXbut') { 
          buttonText = '👫' }
        if ( name === 'SpeXbut') {
          buttonText = '✨'}


        return (
          <div  id = { gridID + '-' + name }
                className = { 'flexicell ' + classRoot + '-cell' }
                style = {{
                  width: `${(colEnd - colStart) * parseInt(colSize, 10)}px`,
                  height: '96%',
                  gridRowStart: rowStart,
                  gridColumnStart: colStart,
                  gridRowEnd: `span ${rowEnd - rowStart}`,
                  gridColumnEnd: `span ${colEnd - colStart}`,
                  zIndex: `1108`,
                  padding: `2px`
                  }}
          >

              <button 
                onClick= { (e) => handleClickCollapse(name) } 
                className = 'cf-in cf-spellbutton'
                style = {{
                  fontSize: `1.4em`  
                }} >
                { buttonText }
              </button>

          </div>
        )
      }

      if ( type === 'img') {
        return (
          <div  id = { gridID + '-' + name }
                className = { 'flexicell ' + classRoot + '-cell' }
                style = {{
                  zIndex: '1050',
                  width: `${(colEnd - colStart) * parseInt(colSize, 10)}px`,
                  height: '96%',
                  gridRowStart: rowStart,
                  gridColumnStart: colStart,
                  gridRowEnd: `span ${rowEnd - rowStart}`,
                  gridColumnEnd: `span ${colEnd - colStart}` }}
          >
          <img 
            src={options.source}
            className = { 'flexicell' + classRoot + '-img' }
            alt=""
            id={ gridID + '-' + name + '-img'}
            style= {{
              zIndex: '1050'
            }}


          />
            </div>
        )
      }

      return (
        <div id={name}
          style = {{
            width: `${(colEnd - colStart) * parseInt(colSize, 10)}px`,
            height: '96%',
            gridRowStart: rowStart,
            gridColumnStart: colStart,
            gridRowEnd: `span ${rowEnd - rowStart}`,
            gridColumnEnd: `span ${colEnd - colStart}`
          }}
        >
          <pre dangerouslySetInnerHTML={{__html: code }} />
        </div> 
      )
    });

    const gridItems = Object.entries(cells).map(([cellName, cell ]) => {

        const [colStart, colEnd, rowStart, rowEnd] = cell;
        const value = data[cellName] || '';


        // TEXT AREAS
        if ( cellName.includes('myAbi') || cellName.includes('myRabi') ) {
          return (
            <div
                id = { gridID + '-' + cellName }
                className = { 'flexicell ' + classRoot + '-cell' }
                style = {{
                    width: `${(colEnd - colStart) * parseInt(colSize, 10)}px`,
                    height: '96%',
                    gridRowStart: rowStart,
                    gridColumnStart: colStart,
                    gridRowEnd: `span ${rowEnd - rowStart}`,
                    gridColumnEnd: `span ${colEnd - colStart}`,
                }}
            >
              <textarea
                className = { classRoot + '-charlong-textbox' }
                id = { gridID + '-' + cellName + '-in' }
                // style={{ fontSize: `${fontSize}pt`, }}
                value={value}
                onDrop={ (e) => { 
                  e.preventDefault();
                  const dropped = JSON.parse(e.dataTransfer.getData('text/plain'))
                  const newData = { ...data };
                  newData[cellName] = ( data[cellName] === "" ? dropped.value :  data[cellName] + '\n' + dropped.value )
                  onDataChange(newData);
                  } }
                onChange={(event) => {
                    const newData = { ...data };
                    newData[cellName] = sanitizeInput(event.target.value);
                    onDataChange(newData);
                }}
              />
            </div>
            );

        }

        // code to calculate font Size automatically
        // const fontSize = Math.min(parseInt(colSize, 10)/ 1.8, 16);
        // height: `${(rowEnd - rowStart) * parseInt(rowSize, 10)}px`,
        // primary return statement. text input inside of a div

        return (

        <div
            id = { gridID + '-' + cellName }
            className = { 'flexicell ' + classRoot + '-cell' }
            style = {{
                width: `${(colEnd - colStart) * parseInt(colSize, 10)}px`,
                height: '96%',
                gridRowStart: rowStart,
                gridColumnStart: colStart,
                gridRowEnd: `span ${rowEnd - rowStart}`,
                gridColumnEnd: `span ${colEnd - colStart}`,
            }}
        >

          <input
            type="text"
            className = { 'flexiinput ' + classRoot + '-in' }
            // id = { gridID + '-' + name + '-in' }
            id = { cellName }  // to make it compatible with GET_DATA
            // style={{ fontSize: `${fontSize}pt`, }}
            value={value}
            onChange={(event) => {
                const newData = { ...data };
                newData[cellName] = sanitizeInput(event.target.value);
                onDataChange(newData);
            }}
          />
        </div>
        );
    });

    const boxItems = Object.entries(boxes).map(([boxName, cell]) => {
      let [colStart, colEnd, rowStart, rowEnd] = cell;
      return (
        <div
              className = { 'flexibox ' }
              id = { classRoot + '-' + boxName }
              style = {{
                  gridRowStart: rowStart,
                  gridColumnStart: colStart,
                  gridRowEnd: `span ${rowEnd - rowStart}`,
                  gridColumnEnd: `span ${colEnd - colStart}`,
                  marginRight: '1px',
                  marginTop: '1px'
              }}
        ></div>
      );      
    });


    function getSpans(cell_def) {
        
        let xValues = [];
        let yValues = [];
        
        for (let key in cell_def) {
          let x1 = cell_def[key][0] || 1;
          let x2 = cell_def[key][1] || 1;
          let y1 = cell_def[key][2] || 1;
          let y2 = cell_def[key][3] || 1;

          xValues.push(x1, x2);
          yValues.push(y1, y2);
        }
        let Xspan = Math.max(...xValues) - Math.min(...xValues) ;
        let Yspan = Math.max(...yValues) - Math.min(...yValues) ;

        return [Xspan, Yspan];
      }

    
    
    // ---------- main return JSX ----------
    //

    const [nCols, nRows] = getSpans(cells);
    //gridTemplateRows: `repeat(${nRows},${rowSize})`

    return (

    // div that is a static grid `nCols` wide x `gridItems.length` long
    //
    // boxItems are border lines overlaid on top

    <div
      className = {'flexigrid ' + classRoot + '-grid ' + inheritedClasses} 
      id =  { gridID }
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${nCols}, ${colSize})`
      }}
    >
      {/* gridTemplateColumns: `repeat(${nCols}, ${colSize})`
          gridTemplateColumns: `repeat(2, 36px) repeat(2, 36px) repeat(2, 36px) repeat(2, 36px)`
      */}
      {htmlItems}
      {gridItems}
      {boxItems}
    </div>
    )

};  // end of function

export default Flexigrid2

/* THIS IS FROM FLEXIGRID 1 - NEEDS UPDATE
Sample usage. Cells defines the input areas, boxes defines the lines
   
   cells={{ datafield1: [ 1,3,1,2 ], datafield2: [1,3,2,3], ... }}

   [ X1, X2, Y1, Y2] where X is the column number and Y is the row number

   the names of 'datafield1' need to be keys in the data dictionary => data[datafield1]
   boxes input does not have this restriction

  <FlexiGrid
    rowSize = '8px'
    colSize = '15px'
    id = {thisCharID+'-grid-sm'}
    classRoot = 'cl'
    cells = {{ name: [1, 10, 1, 4], myClass: [1, 8, 4, 6], myLevel: [8, 10, 4, 6], ... }}
    data = { data }
    onDataChange = {setData}
    boxes={{ box1: [ 1,10,1,10 ], box1A: [1,10,1,4], box2: [ 1,6,10,22 ], box3: [ 6,10,10,22 ], 
              boxHP: [1,10,22,26], boxWeap: [1,10,26,36], boxArm: [1,10,36,46], boxSav: [1,10,46,52],
              boxFol: [1,10,52,56], boxSp1: [1,6,56,63], boxSp2: [6,10,56,63], boxSp3: [1,6,63,69], boxSp4: [6,10,63,69], boxSp5: [1,6,69,74], boxSp6: [6,10,69,74],
              boxMag: [1,10,74,79], boxItems: [1,10,79,89], boxPots: [1,10,89,95], boxRace: [1,10,95,101],
              boxOther: [1,10,101,107], boxGold: [1,10,107,109], boxXP: [1,10,109,113]
        }}
  />
    */